module.exports = __webpack_public_path__ + "static/media/UC_V_FundoClaro-negro.9b0bb6be.png";